import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { NavBar } from "@/components/veguk/NavBar";
import { Hero } from "@/components/veguk/Hero";
import { About } from "@/components/veguk/About";
import { VegTypes } from "@/components/veguk/VegTypes";
import { Exceptions } from "@/components/veguk/Exceptions";
import { FoodPrep } from "@/components/veguk/FoodPrep";
import { EmailPdfSection } from "@/components/veguk/EmailPdfSection";
import { ContactSection } from "@/components/veguk/ContactSection";
import { Footer } from "@/components/veguk/Footer";
import ProtectedAdminRoute from "@/components/veguk/ProtectedAdminRoute";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const Landing = () => (
  <>
    <NavBar />
    <main>
      <Hero />
      <About />
      <VegTypes />
      <Exceptions />
      <FoodPrep />
      <EmailPdfSection />
      <ContactSection />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedAdminRoute>
                <AdminDashboard />
              </ProtectedAdminRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            color: "#2C352D",
            border: "1px solid #D1C9B9",
          },
        }}
      />
    </div>
  );
}

export default App;
